export default __webpack_public_path__ + "static/media/service-Design-Media-Architecture.183d9a94.jpg";